import React from 'react';
import { History, Map, Info, Bird, TreePine, Landmark } from 'lucide-react';

const menuItems = [
  { icon: History, label: 'Historie', id: 'history' },
  { icon: Map, label: 'Ruter', id: 'routes' },
  { icon: Landmark, label: 'Seværdigheder', id: 'attractions' },
  { icon: TreePine, label: 'Flora', id: 'flora' },
  { icon: Bird, label: 'Fauna', id: 'fauna' },
  { icon: Info, label: 'Information', id: 'info' },
];

export default function Navigation({ 
  isOpen, 
  activeSection,
  onSectionChange 
}: { 
  isOpen: boolean;
  activeSection: string;
  onSectionChange: (section: string) => void;
}) {
  return (
    <nav className={`
      fixed top-[60px] left-0 right-0 bg-green-50/80 backdrop-blur-sm
      transform transition-transform duration-300 ease-in-out
      ${isOpen ? 'translate-y-0' : '-translate-y-full'}
    `} style={{ zIndex: 1500 }}>
      <div className="container mx-auto px-4 py-2">
        <ul className="flex flex-col gap-2">
          {menuItems.map(({ icon: Icon, label, id }) => (
            <li key={id}>
              <button
                onClick={() => onSectionChange(id)}
                className={`
                  w-full px-4 py-3 rounded-lg flex items-center gap-3
                  ${activeSection === id ? 'bg-green-100 text-green-900' : 'hover:bg-green-100/50'}
                  transition-colors
                `}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}